import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2db6d12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "CONTACT US", -1))
const _hoisted_3 = { style: {"padding":"0 2vh"} }
const _hoisted_4 = { style: {"padding":"0 2vh"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, reactive, onMounted } from 'vue'
    import type { TabsPaneContext } from 'element-plus'
    import { useRoute, useRouter } from 'vue-router'

    import CardText from '@/components/CardText.vue'
    // import StudentForm from '@/components/StudentForm.vue'
    // import RtoForm from '@/components/RtoForm.vue'
    // import TrainingForm from '@/components/TrainingForm.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'WapContactView',
  setup(__props) {

    const route = useRoute();
    const router = useRouter();

    const redirect = () => {
      window.location.href = "https://gepgrp.com/Geppathway/maintenance/application_form";
    }

    // const activeTab = typeof route.params.tab === 'string' ? route.params.tab : 'student';

    const handleClick = (tab: TabsPaneContext, event: Event) => {
    // console.log(tab, event)
    }

    const onBack = () => {
        router.back();
        // notify('Back')
    }

    const paragraph = [
    {
        title:'Head Office',
        data:'801 Glenferrie Road<br>Hawthorn VIC 3122<br>AUSTRALIA<br>WEBSITE: www.gepgrp.com<br>Email: Info@gepgrp.com'
    },
    {
        title:'Philippines',
        data:'Unit 2306A Centuria Medical Makati<br>Crn Salamanca and Kalayaan Sts<br>Barangay Poblacion, Makati City 1210'
    },
    {
        title:'Cameroon',
        data:'Global Business Group<br>Carrefour Roi<br>Belle, Bonaberi<br>Douala, Cameroon<br>'
    },
    {
        title:'Iran',
        data:'Gohar Daanesh Iranian<br>Mr. Nader Saeedi'
    },
    {
        title:'Saudi Arabia',
        data:'6843 Ismaeli Alakhbari<br>Aiajawad District<br>Jeddah 23466-3125<br>SAUDI ARABIA<br>Saeed Abdullah Alkhuraimi'
    }
    ];

    const data = reactive(
    {
        paragraph:paragraph
    }
    );



return (_ctx: any,_cache: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_page_header, { onBack: onBack })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("button", {
        class: "button-23",
        onClick: redirect
      }, "Click Here To Start Your Application"),
      _createVNode(CardText, {
        value: data.paragraph
      }, null, 8, ["value"])
    ]),
    _hoisted_6
  ]))
}
}

})